module.exports = __webpack_public_path__ + "static/seal-of-up-61d100af8fa4b11eb1d4f339919a8210.png";